import { cn } from '@/utils/cn'
import type { RiskLevel } from '@/types'

interface RiskIndicatorProps {
  level: RiskLevel
  score?: number
}

const colors: Record<RiskLevel, string> = {
  low: 'bg-green-100 text-green-800',
  medium: 'bg-yellow-100 text-yellow-800',
  high: 'bg-red-100 text-red-800',
}

const icons: Record<RiskLevel, string> = {
  low: '🟢',
  medium: '🟡',
  high: '🔴',
}

export function RiskIndicator({ level, score }: RiskIndicatorProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center gap-2 rounded-full px-3 py-1',
        colors[level]
      )}
    >
      <span>{icons[level]}</span>
      <span className="font-medium capitalize">{level}</span>
      {score !== undefined && (
        <span className="text-sm opacity-70">({Math.round(score * 100)}%)</span>
      )}
    </div>
  )
}
